import React from "react";

function MainStep({ handleChange, formData }) {
  return (
    <>
      <div className="row pb-1 pb-sm-2 pb-md-3 pb-lg-4 pb-xl-5">
        <div className="col-lg-12">
          <div className="pt-3 mt-3">
            <h2 className="h6 pb-1 mb-3 color_grey">How Can We Help You?</h2>

            {/* Required Field: Must choose one. */}
            <div className="nav nav-pills row row-cols-2 row-cols-sm-3 row-cols-md-3 gap-0 g-3">
              <div className="col">
                <input
                  type="radio"
                  className="btn-check"
                  id="website"
                  name="projectType"
                  value="Website"
                  onChange={handleChange}
                  checked={formData.projectType === "Website"}
                />
                <label
                  className="nav-link flex-column w-100 align-items-center gap-2 rounded p-3"
                  htmlFor="website"
                >
                  <img
                    className="main__icon"
                    src="/assets/icons/design.svg"
                  ></img>

                  <div className="main_card_info">
                    <h3>Website</h3>
                    <p>Custom Corporate Website for You.</p>
                  </div>
                </label>
              </div>

              <div className="col">
                <input
                  type="radio"
                  className="btn-check"
                  id="ecommerce"
                  name="projectType"
                  value="E-Commerce"
                  onChange={handleChange}
                  checked={formData.projectType === "E-Commerce"}
                />
                <label
                  className="nav-link flex-column w-100 align-items-center gap-2 rounded p-3"
                  htmlFor="ecommerce"
                >
                  <img
                    className="main__icon"
                    src="/assets/icons/commerce.svg"
                  ></img>

                  <div className="main_card_info">
                    <h3>E-Commerce</h3>
                    <p>Custom E-Commerce Website for You.</p>
                  </div>
                </label>
              </div>
              <div className="col">
                <input
                  type="radio"
                  className="btn-check"
                  id="custom"
                  name="projectType"
                  value="Custom Web Software"
                  onChange={handleChange}
                  checked={formData.projectType === "Custom Web Software"}
                />
                <label
                  className="nav-link flex-column w-100 align-items-center gap-2 rounded p-3"
                  htmlFor="custom"
                >
                  <img
                    className="main__icon"
                    src="/assets/icons/custom.svg"
                  ></img>

                  <div className="main_card_info">
                    <h3>Custom Web Software</h3>
                    <p>Custom CRM, ERP Software for You.</p>
                  </div>
                </label>
              </div>

              <div className="col">
                <input
                  type="radio"
                  className="btn-check"
                  id="app"
                  name="projectType"
                  value="Mobile Application"
                  onChange={handleChange}
                  checked={formData.projectType === "Mobile Application"}
                />
                <label
                  className="nav-link flex-column w-100 align-items-center gap-2 rounded p-3"
                  htmlFor="app"
                >
                  <img className="main__icon" src="/assets/icons/app.svg"></img>

                  <div className="main_card_info">
                    <h3>Mobile Application</h3>
                    <p>Custom solutions for iOS and Android devices.</p>
                  </div>
                </label>
              </div>
              <div className="col">
                <input
                  type="radio"
                  className="btn-check"
                  id="iot"
                  name="projectType"
                  value="Internet of Things"
                  onChange={handleChange}
                  checked={formData.projectType === "Internet of Things"}
                />
                <label
                  className="nav-link flex-column w-100 align-items-center gap-2 rounded p-3"
                  htmlFor="iot"
                >
                  <img className="main__icon" src="/assets/icons/iot.svg"></img>

                  <div className="main_card_info">
                    <h3>Internet of Things (IoT)</h3>
                    <p>
                      IoT and Wearable Technologies, Smart Home Solutions, etc.
                    </p>
                  </div>
                </label>
              </div>
              <div className="col">
                <input
                  type="radio"
                  className="btn-check"
                  id="embedded"
                  name="projectType"
                  value="Embedded Systems"
                  onChange={handleChange}
                  checked={formData.projectType === "Embedded Systems"}
                />
                <label
                  className="nav-link flex-column w-100 align-items-center gap-2 rounded p-3"
                  htmlFor="embedded"
                >
                  <img
                    className="main__icon"
                    src="/assets/icons/chip.svg"
                  ></img>

                  <div className="main_card_info">
                    <h3>Embedded Systems</h3>
                    <p>PCB - FPGA Design, Sensors, Embedded Software, etc.</p>
                  </div>
                </label>
              </div>
              <div className="col">
                <input
                  type="radio"
                  className="btn-check"
                  id="engineering"
                  name="projectType"
                  value="Engineering Solutions"
                  onChange={handleChange}
                  checked={formData.projectType === "Engineering Solutions"}
                />
                <label
                  className="nav-link flex-column w-100 align-items-center gap-2 rounded p-3"
                  htmlFor="engineering"
                >
                  <img
                    className="main__icon"
                    src="/assets/icons/ai-main.svg"
                  ></img>

                  <div className="main_card_info">
                    <h3>Engineering Solutions</h3>
                    <p>
                      Machine Learning, Artificial Intelligence, AR - VR, Big
                      Data, DevOps, etc.
                    </p>
                  </div>
                </label>
              </div>
              <div className="col">
                <input
                  type="radio"
                  className="btn-check"
                  id="consulting"
                  name="projectType"
                  value="Technology Consulting"
                  onChange={handleChange}
                  checked={formData.projectType === "Technology Consulting"}
                />
                <label
                  className="nav-link flex-column w-100 align-items-center gap-2 rounded p-3"
                  htmlFor="consulting"
                >
                  <img
                    className="main__icon"
                    src="/assets/icons/consulting.svg"
                  ></img>

                  <div className="main_card_info">
                    <h3>Technology Consulting</h3>
                    <p>
                      Corporate Software, Data Management and Analysis,
                      Consulting, etc.
                    </p>
                  </div>
                </label>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default MainStep;
